import { render, staticRenderFns } from "./RateCardsTable.vue?vue&type=template&id=6a542d40&"
import script from "./RateCardsTable.vue?vue&type=script&lang=js&"
export * from "./RateCardsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports